import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69c2d9767d947e0014cb909c/spaceracer/src/app/game-screen/components/GameCanvas.tsx");
